export const defaultState: ApplicationState = {
  user: undefined
};

export default defaultState;
